export default function makeSetHoveredColumnControls(store) {
  return {
    setHoveredColumnControls: function setHoveredColumnControls(editor, columnIndex) {
      store.updateItem('hoveredColumnControls', columnIndex);
      return editor;
    }
  };
}